import { Locale, type LocalizedString } from "../Locale.js";

export const localeNameMap: Record<Locale, LocalizedString> = {
	[Locale.cs]: {
		[Locale.cs]: "Čeština",
		[Locale.en]: "Angličtina",
	},
	[Locale.en]: {
		[Locale.cs]: "Czech",
		[Locale.en]: "English",
	},
};
